import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import action from '../../../../actions/index';
import HomestayRoomTypes from './HomestayRoomTypes';
import * as homestayActions from './../../../../actions/homestayAction';

const mapStateToProps = state => {
    return {
        homestayRoomTypeState: state.homestayRoomTypeReducer,
        homestayState: state.homestayReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListHomestayRoomTypes: (filters) => {
            dispatch(action.getListHomestayRoomTypes(filters))
        },
        getHomestayDetail: (id) => dispatch(homestayActions.getHomestayDetail(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(HomestayRoomTypes));
